import { Measurement, Tags, TagBuilder } from './Measurement';
import { IMessagingClient, IMeasurementTags, IMeasurement } from '@agoda/messaging-client';
import { MessageType } from '@services/messagingClient/MessageType';
import { toADPTags } from '@services/utils/toADPTags';
import { AppContextData } from '@contexts/app/AppContextData';

export class ADPMeasurement implements Measurement {
    private readonly messagingClient: IMessagingClient;
    private readonly appContext: AppContextData;
    private readonly baseTags: Tags = {};

    constructor(messagingClient: IMessagingClient, appContext: AppContextData) {
        this.appContext = appContext;
        this.messagingClient = messagingClient;

        const {
            appId,
            clientVersion,
            devicePlatformId,
            origin,
            whitelabelId,
            machineName,
            correlationId,
            appVersion,
        } = appContext;
        this.baseTags = {
            appId,
            appVersion,
            clientVersion,
            devicePlatformId,
            origin,
            whitelabelId,
            machineName,
            correlationId,
        };
    }

    private sendMeasurement(name: string, measurement: number, tags?: IMeasurementTags) {
        const body: IMeasurement = {
            name,
            measurement,
            tags,
            count: 1,
        };

        const message = this.messagingClient.create(MessageType.Measurement, body);
        this.messagingClient.send(message);
    }

    public count = (name: string, count: number = 1, tags?: Tags) => {
        const measurementTags = toADPTags({ ...this.baseTags, ...tags });
        this.sendMeasurement(name, count, measurementTags);
    };

    public measurePromise = <TRes>(name: string, measured: Promise<TRes>, tags?: Tags | TagBuilder<TRes>) => {
        const start = performance.now();
        const measurementTags = { ...this.baseTags };

        let elapseTime = 0;

        return new Promise<TRes>((resolve, reject) =>
            measured
                .then(response => {
                    elapseTime = performance.now() - start;
                    Object.assign(measurementTags, {
                        ...(typeof tags === 'function' ? tags(response) : tags),
                        promiseResolved: true,
                    });

                    this.sendMeasurement(name, elapseTime, toADPTags(measurementTags));

                    resolve(response);
                })
                .catch(error => {
                    elapseTime = performance.now() - start;
                    Object.assign(measurementTags, {
                        ...(typeof tags === 'function' ? tags() : tags),
                        promiseResolved: false,
                    });

                    this.sendMeasurement(name, elapseTime, toADPTags(measurementTags));

                    reject(error);
                })
        );
    };
}
